import { useQuery } from '@apollo/client';
import { getMarksixResultQuery } from '../Data/DataQuery';
import { useBroadcastChannel } from '../../Common/hooks';
import { useActivateUser } from '../../BetSlip/SsoHook';

const M6ResultMatrix = () => {

    const resGqlVars = useQuery(getMarksixResultQuery(), {
        variables: { "lastNDraw": 30,
            "drawType": 'All',
            "startDate": null,
            "endDate": null
        },
        fetchPolicy: 'no-cache',
        notifyOnNetworkStatusChange: true,
    });

    const draws = resGqlVars?.data?.lotteryDraws;
    
    if ( !draws ) {
        return <div></div>
    }

    const isResultNo = (draw, i) => {
        return draw.drawResult.drawnNo.includes(i) || draw.drawResult.xDrawnNo==i;
    }

    const isSpecialNo = (draw, i) => {
        return draw.drawResult.xDrawnNo==i;
    }

    const broadcast_resetlogin = useBroadcastChannel('resetLoginTimeout');
    useActivateUser({
        activateUser: () => {
            if (window.globalConfig.NEW_LOGOUT_REMINDER_FLOW) {
                broadcast_resetlogin?.postMessage(false)
            }
        }
    });

    let output = [];
    for ( let i = 1; i<=49; i++ ) {
        output.push(<tr>
            <td>
                <img
                className={`ballsize-s`}
                src={require(`../../../info/marksix/info/images/marksix-${i}.svg`)}
                alt={i} />
            </td>
            {draws.map(d => 
                <td style={{textAlign:"center"}}>{isResultNo(d, i) ?
                    <img style={isSpecialNo(d, i) ? { border: "2px solid black", borderRadius: "50px" } : {}}
                    className={`ballsize-s`}
                    src={require(`../../../info/marksix/info/images/marksix-${i}.svg`)}
                    alt={i} /> : ""
                }</td>
            )}
        </tr>);
    }

    return <div>
        <style>{`
            table, th, td {
                border: 1px solid black;
                border-collapse: collapse;
            }
        `}</style>
        <table>
            <tr>
                <td></td>
                {draws.map(d => 
                    <td style={{whiteSpace: "noWrap"}}>{d.drawDate.substring(0,10)}</td>
                )}
            </tr>
            {output}
        </table>
    </div>
}

export default M6ResultMatrix